export default "__VITE_ASSET__702bbae2__"